import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

interface PageTitleProps {
  title: string;
  backButton?: boolean;
  backPath?: string;
  subtitle?: string;
}

export function PageTitle({
  title,
  backButton = false,
  backPath = "/",
  subtitle,
}: PageTitleProps) {
  return (
    <div className="flex flex-row items-center gap-4 pt-2 pb-6">
      {backButton && (
        <Link
          to={backPath}
          className="group flex items-center justify-center w-10 h-10 rounded-xl bg-white shadow-sm border border-gray-100 hover:shadow-md hover:border-[#0085BD]/30 transition-all duration-200"
        >
          <MdArrowBack
            size={20}
            className="text-[#0085BD] transition-transform duration-200 group-hover:-translate-x-0.5"
          />
        </Link>
      )}
      <div className="flex-1">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-[#0085BD] to-[#006a96] bg-clip-text text-transparent">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
